<template>
  <Dialog v-model="dialog">
    <Card>
      <CardHeader>
        <CardTitle>{{ title }}</CardTitle>
      </CardHeader>
      <CardBody center>
        <CardText>
          {{ body }}
        </CardText>
      </CardBody>
    </Card>
  </Dialog>
</template>

<script>
import {
  Dialog,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  CardText
} from '@neurotrack/web-shared-components'

const MIN_DEVICE_WIDTH = 1024
const MIN_DEVICE_HEIGHT = 720
const MIN_VIEWPORT_WIDTH = 940
const MIN_VIEWPORT_HEIGHT = 540

export default {
  data() {
    return {
      height: 9999,
      width: 9999,
      deviceHeight: 9999,
      deviceWidth: 9999
    }
  },
  components: {
    Dialog,
    Card,
    CardHeader,
    CardTitle,
    CardBody,
    CardText
  },
  mounted() {
    this.onResize()
    window.addEventListener('resize', this.onResize)
    window.addEventListener('focus', this.onResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
    window.removeEventListener('focus', this.onResize)
  },
  methods: {
    onResize() {
      this.width = window.innerWidth
      this.height = window.innerHeight
      this.deviceWidth = window.screen.width
      this.deviceHeight = window.screen.height
    }
  },
  computed: {
    isInvalidDevice() {
      return (
        this.deviceWidth < MIN_DEVICE_WIDTH
        || this.deviceHeight < MIN_DEVICE_HEIGHT
      )
    },
    isInvalidViewport() {
      return (
        this.width < MIN_VIEWPORT_WIDTH || this.height < MIN_VIEWPORT_HEIGHT
      )
    },
    dialog() {
      return this.isInvalidDevice || this.isInvalidViewport
    },
    title() {
      return this.isInvalidDevice
        ? this.$t('error_device_unsupported_header')
        : this.$t('error_browser_viewport_header')
    },
    body() {
      return this.isInvalidDevice
        ? this.$t('error_device_display_body')
        : this.$t('error_browser_viewport_body')
    }
  }
}
</script>
